<ui-icon [name]="iconName()" [color]="statusColor()" [onColoredBackground]="{ color: statusColor() }" />
<div class="medium-padding-left" [style.color]="statusColor() | sharedUiTextOnColoredBackgroundColor$ | async">{{ message() }}</div>
